// @ts-expect-error moduleResolution:nodenext issue 54523
import { html, nothing } from 'lit';
// @ts-expect-error moduleResolution:nodenext issue 54523
import { Task, TaskStatus } from '@lit/task';
// @ts-expect-error moduleResolution:nodenext issue 54523
import { customElement, property, state } from 'lit/decorators.js';
import LightElement from './light-element.js';
import { IProductViewer } from '../models/IProductViewer.model.js';
import Logger from '../../typescript/modules/Logger.js';
// @ts-expect-error moduleResolution:nodenext issue 54523
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import TrapFocus from "../../typescript/modules/trap-focus";
import SlideToggle from '../../typescript/modules/slide-toggle';
import YotpoLoader from "../../typescript/modules/yotpo-loader";
// @ts-expect-error moduleResolution:nodenext issue 54523
import { ifDefined } from 'lit/directives/if-defined.js';
import Helpers from '../../typescript/modules/helpers.js';
import ImageZoom from '../../typescript/modules/image-zoom.js';
import Lockout from '../../typescript/modules/lockout.js';
import RevealContent from '../../typescript/modules/reveal-content.js';
// @ts-expect-error moduleResolution:nodenext issue 54523
import { classMap } from 'lit/directives/class-map.js';
import { createRef, ref, Ref } from 'lit/directives/ref.js';
import { VariantSelectorElement } from './product-variant-selector.js';
import Tooltip from '../../typescript/modules/tooltip.js';

declare var Splide: any;

@customElement('product-viewer')
export default class ProductViewer extends LightElement {

	@property({ type: String, reflect: true })
	productId?: string;

	@property({ type: String, reflect: true })
	sku: string;

	@property({ type: Boolean })
	standalone: boolean;

	@property({ type: Number })
	initialQuantity = 0;

	@property({ type: Boolean })
	isComparingMode: boolean;

	@state()
	details: IProductViewer;

	@state()
	private canAddToBasket: boolean = false;

	private instances = {
		slideshow: null as any,
		loaderTimeout: 0
	};
	private detailOverlayTrapFocus: TrapFocus;

	private _productTask = new Task(this, {
		task: async ([productId, sku], { signal }) => {
			const response = await fetch(`/api/productviewer/getproduct/?id=${productId}&quantity=${this.getQuantity(productId, sku ?? productId)}${sku ? `&sku=${sku}` : ''}`, { signal });
			if (!response.ok) { throw new Error(response.status.toString()); }
			this.details = await response.json() as unknown as IProductViewer;
			return this.details;
		},
		args: () => [this.productId, this.sku]
	});

	private maxKeyFeaturesForVariants = 5;
	private maxKeyFeatures = 10;

	@property({ type: Boolean })
	rerender: boolean;

	variantSelectorElement: Ref<VariantSelectorElement> = createRef();

	connectedCallback() {
		super.connectedCallback();
		if (this.standalone) {
			Lockout.on();
		}
	}

	disconnectedCallback() {
		super.disconnectedCallback();
		if (this.detailOverlayTrapFocus) {
			this.detailOverlayTrapFocus.removeListener();
		}
		if (this.standalone) {
			Lockout.off();
		}
	}

	updated(changedProperties) {
		if (changedProperties.has('productId') || changedProperties.has('sku')) {
			this.checkHasLoaded();
		}
	}

	private getQuantity(productId: string, sku: string) {

		if (!(<any>window).addedProducts) {
			return this.initialQuantity;
		}

		const found = (<any>window).addedProducts.find((product) => product.id === productId && product.sku === sku);

		if (found) {
			return found.quantity;
		}

		return this.initialQuantity
	}

	private checkHasLoaded() {
		if (this._productTask.status === TaskStatus.COMPLETE) {
			this.initScripts();
		} else {
			window.setTimeout(() => this.checkHasLoaded(), 100);
		}
	}

	private initScripts() {

		this.rerender = true;

		setTimeout(() => {
			this.rerender = false;
			setTimeout(() => {
				this.initSlider();
				this.initFocusTrap();
				new SlideToggle();
				new YotpoLoader(this.querySelectorAll('.js-load-yotpo'));
				this.focusOnFirstItemInDetails();
				const triggerUpdateWishlistButtons = Helpers.createCustomEventForDispatch('updateWishlistButtons');
				document.dispatchEvent(triggerUpdateWishlistButtons);
				this.canAddToBasket = this.initialBasketButtonState();
				const imagesToZoom = this.querySelectorAll('.js-image-zoom') as NodeListOf<HTMLElement>;
				for (var i = 0; i < imagesToZoom.length; i++) {
					new ImageZoom(imagesToZoom[i]);
				}
				new RevealContent(this.querySelectorAll('.js-reveal-content'));
				Tooltip.init(false);
				this.variantWacher();
			}, 25);
		}, 25);

	}

	private initialBasketButtonState() {
		if (!this.details) {
			return false;
		}
		if (this.sku) {
			return true;
		}
		return this.details.Product.VariantOptionGroups?.length ? false : true;
	}

	private isSelectionValid(showValidationErrors: boolean) {
		if (!this.details) {
			return false;
		}
		if (this.variantSelectorElement.value) {
			if (!this.variantSelectorElement?.value.isValid(showValidationErrors)) {
				return false;
			}
		}
		return true;
	}

	private initFocusTrap() {
		this.detailOverlayTrapFocus = new TrapFocus(document.querySelector('.c-slidy-outy__detail'));
	}

	private initSlider() {
		try {
			if (this.instances.slideshow) {
				this.instances.slideshow.destroy(true);
			}
			if (document.querySelectorAll('[data-product-viewer-item-slideshow-item]').length > 1) {
				this.instances.slideshow = new Splide('[data-product-viewer-item-slideshow-container]', {
					type: 'fade',
					perPage: 1,
					perMove: 1,
					speed: 600,
					interval: 5000,
					heightRatio: 1,
					pagination: true,
					rewind: true,
					arrows: true,
					keyboard: 'focused',
					arrowPath: 'M1.14 39.85a1.12 1.12 0 01-.72-.26 1.17 1.17 0 01-.16-1.63l14.72-18.11L.24 1.78A1.15 1.15 0 01.6.19a1.14 1.14 0 011.44.16l15.94 19.5L2.04 39.43a1.15 1.15 0 01-.9.42z',
					classes: {
						prev: 'c-carousel__button c-carousel__button--left js-carousel-button-left',
						next: 'c-carousel__button c-carousel__button--right js-carousel-button-right',
						pagination: 'c-carousel__pagination',
						page: 'c-carousel__pagination-page'
					}
				});

				this.instances.slideshow.on('mounted', () => {
					setTimeout(() => {
						const containerParentElement = document.querySelector('[data-product-viewer-item-slideshow-container]');
						if (containerParentElement) {
							containerParentElement.removeAttribute('tabindex');
							const slides = containerParentElement.querySelectorAll('.splide__slide');
							for (var i = 0; i < slides.length; i++) { slides[i].removeAttribute('tabindex'); }
						}
					}, 1000);
				});

				this.instances.slideshow.mount();
			} else {
				document.querySelector('[data-product-viewer-item-slideshow-container]').classList.add('c-carousel--single');
			}

		} catch (error) {
			Logger.trackException(error);
		}
	}

	private focusOnFirstItemInDetails() {
		setTimeout(() => {
			const focusableElements = document.querySelectorAll('[data-product-viewer] [data-product-viewer-close]');
			const firstFocusableElement = focusableElements[0] as HTMLLinkElement;
			if (firstFocusableElement) {
				firstFocusableElement.focus();
			}
		}, 250);
	}

	private variantWacher() {
		this.variantSelectorElement.value?.addEventListener('variant-changed', (event: any) => {
			const { currentVariant } = event.detail;
			if (currentVariant) {
				this.sku = currentVariant.Sku;
			}
		});
	}

	private handleRatingClick() {
		const reviewsAccordionTrigger = this.querySelector('#accordion-product-viewer-accordion-reviews') as HTMLButtonElement;
		if (reviewsAccordionTrigger) {
			if (reviewsAccordionTrigger.getAttribute('aria-expanded') === 'false') {
				reviewsAccordionTrigger.click();
			}
			reviewsAccordionTrigger.scrollIntoView();
		}
	}

	private close() {
		const triggerCloseProductViewer = Helpers.createCustomEventForDispatch('closeProductViewer');
		document.dispatchEvent(triggerCloseProductViewer);
	}

	private renderLoadingState() {
		return html`
		<div class="c-slidy-outy__detail__loader" data-product-viewer-loader>
			<div class="c-slidy-outy__detail__loader__element">
				<div class="c-slidy-outy__detail__loader__circle c-slidy-outy__detail__loader__circle--1"></div>
				<div class="c-slidy-outy__detail__loader__circle c-slidy-outy__detail__loader__circle--2"></div>
				<div class="c-slidy-outy__detail__loader__circle c-slidy-outy__detail__loader__circle--3"></div>
			</div>
		</div>
		`;
	}

	private renderErrorState() {
		return html`
			<div class="c-slidy-outy__detail__item">
				<h2>Unable to get product details. Please close this overlay and try again later.</h2>
			</div>
		`;
	}

	private isDesktop() {
		return matchMedia('(min-width: 980px)').matches;
	}

	private renderProductDetails(details: IProductViewer) {

		if (this.rerender) {
			return nothing;
		}

		return html`
			<div class="c-slidy-outy__detail__item ${classMap({ "is-loading": this._productTask.status === TaskStatus.PENDING, "c-slidy-outy__detail__item--has-variants": details.Product.VariantOptionGroups?.length, "c-slidy-outy__detail__item--no-keyfeatures": !details.Product.KeyFeatures?.length })}" data-product-viewer-item="${details.Product.Id}" data-test="product-viewer">

			<div class="c-slidy-outy__detail__body">

						<div class="c-slidy-outy__detail__top">
							<h2 class="c-slidy-outy__detail__item__title u-bold" data-test="product-viewer-item-title" id="slidy-outy-title">${details.Product.DisplayName}</h2>
							<button @click=${this.close.bind(this)} type="button" class="c-slidy-outy__detail__close" data-product-viewer-close data-test="product-viewer-close"><span class="c-slidy-outy__detail__close__text">Close</span> <span class="u-visuallyhidden">product overlay</span></button>
						</div>

						<div class="c-slidy-outy__detail__header">

							<div class="c-slidy-outy__detail__header__images">

								<div class="c-slidy-outy__detail__header__images__inner">

								${details.Product.Gallery.ItemCount > 0 ?
								html`
									<div class="c-slidy-outy__detail__carousel c-carousel c-carousel--with-pagination c-carousel--atb splide" data-product-viewer-item-slideshow-container>
										<div class="c-carousel__inner splide__track">
											<ul class="c-carousel__list js-slideshow-list splide__list" data-product-viewer-item-slideshow data-test="product-viewer-gallery">
											${details.Product.Gallery.Items.map(image => html`
												${image.IsImage || image.IsVideo ? html`
												<li class="c-carousel__item js-slideshow-item splide__slide js-image-zoom-container" data-product-viewer-item-slideshow-item>
													<div class="c-slidy-outy__detail__item__slideshow__item__inner">
														${image.IsImage ? html`
												<div class="js-image-zoom c-image-zoom">
													<button type="button" class="js-image-zoom-button c-image-zoom__button">
														<img src="/images/icons/svgs/zoom-in.svg?v=21045" class="c-image-zoom__button-icon js-image-zoom-button-zoom-in noPrint" loading="lazy" alt="" />
														<img src="/images/icons/svgs/zoom-out.svg?v=21045" class="c-image-zoom__button-icon js-image-zoom-button-zoom-out is-hidden noPrint" loading="lazy" alt="" />
														<span class="u-visuallyhidden">Toggle zoom. Once enabled, arrow keys control the zoom image position and the escape key will come out of image zoom.</span>
													</button>
															<picture>
																<source srcset="${image.Url}?height=490&width=490&mode=crop&scale=both&quality=80&format=webp 1x, ${image.Url}?height=980&width=980&mode=crop&scale=both&quality=80&format=webp 2x" type="image/webp">
																<img src="${image.Url}?height=490&width=490&mode=crop&scale=both&quality=80" width="490" height="490" alt="" class="c-slidy-outy__detail__item__slideshow__image js-image-to-zoom" />
															</picture>
														</div>
														<p class="c-image-zoom__text js-image-zoom-text">Click the image to zoom</p>
														`: nothing}
														${image.IsVideo ? html`
															<div class="c-slidy-outy__detail__item__video">
																<iframe src="https://player.vimeo.com/video/${image.VideoMediaId}" loading="lazy" frameborder="0" allow="autoplay; fullscreen" allowfullscreen class="js-gibe-gallery-stage__video__iframe" data-id="${image.VideoMediaId}"></iframe>
															</div>
														` : nothing}
													</div>
												</li>
												`: nothing}
											`)}
											</ul>
										</div>
									</div>`
								: nothing}

								</div>
							</div>

							<div class="c-slidy-outy__detail__header__content">

								<div class="c-product__price-wishlist-group">
									<div class="c-slidy-outy__detail__item__price">
										<product-main-price
												hideRrp="${ifDefined(details.Product.HideRrp ? true : undefined)}"
												showSaleWasPrice="${ifDefined(details.Product.ShowSaleWasPrice ? true : undefined)}"
												isTradeCustomer="${ifDefined(details.Product.IsTradeCustomer ? true : undefined)}"
												retailPrice="${JSON.stringify(details.Product.RetailPrice)}"
												originalPrice="${JSON.stringify(details.Product.OriginalPrice)}"
												rrp="${JSON.stringify(details.Product.RRP)}"
												hasVariants="${ifDefined(details.Product.HasVariants ? true : undefined)}"
												price='${JSON.stringify(details.Product.Price)}'
												percentageSaving="${details.Product.PercentSaving}"
												variantIsSelected="${this.isSelectionValid(false) || nothing}"
												tradeSaving="${details.Product.TradeSaving}"
												></product-main-price>
									</div>

									<wishlist-button productName="${details.Product.Id}" shiftLeft />

								</div>

								${details.Product.ReviewCount > 0 ?
								html`
									<div class="c-slidy-outy__detail__reviews" data-test="product-viewer-rating">
										<product-rating reviewPercentage="${details.Product.ReviewPercentage}" reviewCount="${details.Product.ReviewCount}" reviewScore="${details.Product.ReviewScore}" longText smallTextMobile alwaysLarge isClickable .onRatingClick="${() => this.handleRatingClick()}" />
									</div>
								` : nothing
								}

								${details.Product.HasOverlays ?
								html`
									<div class="c-slidy-outy__detail__overlay c-merch-overlay__group" data-test="product-viewer-overlay">
										${details.Product.Overlays.map((overlay) => {
											return html`
												<merch-overlay
													shortText="${overlay.ShortText}"
													backgroundColor="${overlay.Theme.BackgroundColor}"
													textColor="${overlay.Theme.TextColor}"
												></merch-overlay>
											`;
										})}
									</div>`
								: null}

								${details.Product.VariantOptionGroups?.length ?
								html`
									<div class="c-slidy-outy__detail__variants">
										<product-variant-selector .variants="${details.Product.VariantLookup}" .variantOptionGroups="${details.Product.VariantOptionGroups}" ${ref(this.variantSelectorElement)}></product-variant-selector>
									</div>
									`
								: null}

								<div class="c-slidy-outy__detail__item__quantity">

									${this.isComparingMode ?
										html`<product-comparison-add
											parentId="${this.productId}"
											productId="${this.sku ? this.sku : this.productId}"
											?disable="${!this.canAddToBasket}"
											.onSelected=${this.close.bind(this)}
											data-test="product-viewer-compare-add"
										></product-comparison-add>`
										: html`<product-add
										viewItemEventInfo='${details.Product.ViewItemEventInfoJson}'
										name="${this.productId}"
										sku="${this.sku ? this.sku : this.productId}"
										displayName="${details.Product.DisplayName}"
										guid="${details.Product.Guid}"
										price="${details.Product.Price.Price}"
										loggerSource="${this.standalone ? "Product Viewer" : "Add To Basket Overlay Product Detail"}"
										?disableAddToBasket="${!this.canAddToBasket}"
										.onChangeQuantity="${() => this.canAddToBasket = this.isSelectionValid(true)}"
										primaryButton
										slim></product-add>`}
								</div>

								<div class="c-slidy-outy__detail__item__stock">
									<p class="c-delivery c-delivery--always-show-extra c-delivery--${details.Product.Stock.CssClass} c-delivery--large" data-test="product-viewer-delivery-message">${unsafeHTML(details.Product.DeliveryEstimate)}</p>
								</div>

								${details.Product.KeyAttributes.length ?
								html` 
									<div class="c-key-attributes c-key-attributes--${details.Product.KeyAttributes.length}" data-test="product-viewer-key-attributes">
										<div class="c-key-attributes__items">
										${details.Product.KeyAttributes.map(keyAttribute => html`
											<div class="c-key-attributes__item">
												${
													keyAttribute.IconUrl ? html`
														<img src="${keyAttribute.IconUrl}" alt="" class="c-key-attributes__item-icon" />
													` : nothing
												}
												<span class="c-key-attributes__item-body">
													<span class="c-key-attributes__label">
														${keyAttribute.DisplayName}
														${keyAttribute.Tooltip ? html`
															<a href="#tooltip-key-attribute-${details.Product.Id}-${keyAttribute.Name}" class="js-tooltip-trigger" data-js-tooltip-trigger data-js-tooltip-trigger-position="bottom"><span class="u-visuallyhidden">More information</span></a>
														` : nothing}
													</span>
												<span class="c-key-attributes__value u-bold">
													${keyAttribute.Value ? keyAttribute.Value : keyAttribute.IsParentProduct ? html`<a class="u-link scrollDone js-show-variant-errors" href="#product">Select an option first</a>` : "—"}
												</span>
												</span>
											</div>
											${keyAttribute.Tooltip ? html`
												<div class="js-tooltip js-tooltip--in-overlay" id="tooltip-key-attribute-${details.Product.Id}-${keyAttribute.Name}" data-js-tooltip>
													<div class="js-tooltip__inner" data-js-tooltip-inner>
														<div class="cms">
															${unsafeHTML(keyAttribute.Tooltip)}
														</div>
													</div>
												</div>
											` : nothing}
										`)}
										</div>
									</div>
									`
								: nothing}

								${details.Product.KeyFeatures.length ?
									html`
											<h3 class="c-slidy-outy__detail__item__features__title u-bold">What's great about it?</h3>
											<div class="c-cms" data-test="product-viewer-features">
												<ul>
													${details.Product.KeyFeatures.slice(0, details.Product.VariantOptionGroups?.length ? this.maxKeyFeaturesForVariants : this.maxKeyFeatures).map(feature => html`
														<li>${feature}</li>
													`)}
												</ul>
											</div>`
								: nothing}

						</div>
					</div>

			</div>

			<div class="c-slidy-outy__detail__footer">
				<div class="c-accordion">

					${details.Product.Description ?
					html`
						<h3 class="c-accordion__heading" data-test="product-viewer-description"><button type="button" class="c-accordion__title js-slide-toggle" aria-controls="accordion-product-viewer-description-content" aria-expanded="${this.isDesktop() ? "true" : "false" }" data-transition-time="300" data-test="product-viewer-description-toggle" id="accordion-product-viewer-description">Description</button></h3>
						<div class="c-accordion__content ${this.isDesktop() ? "is-open" : "false" }" data-test="product-viewer-description-content" id="accordion-product-viewer-description-content" aria-labelledby="accordion-product-viewer-description" aria-hidden="${this.isDesktop() ? "false" : "true" }" data-test="product-viewer-description">
							<div class="c-accordion__content__inner">
								<div class="${this.isDesktop() ? "c-reveal c-reveal--active c-reveal--active-product-viewer js-reveal-content" : ""}" data-reveal-closed-max-height="100" data-test="description-reveal">
									<div class="c-cms c-cms--small-titles c-cms--small-lists">
										${unsafeHTML(details.Product.Description)}
									</div>
								</div>
							</div>
						</div>
					`
					: nothing}

					${details.Product.SpecificationTable.length ? html`
					<h3 class="c-accordion__heading" data-test="product-viewer-specification"><button type="button" class="c-accordion__title js-slide-toggle" aria-controls="accordion-product-viewer-specification-content" aria-expanded="false" data-transition-time="300" data-test="product-viewer-specification-toggle" id="accordion-product-viewer-specification">Specification</button></h3>
					<div class="c-accordion__content" id="accordion-product-viewer-specification-content" data-test="product-viewer-specification-content"  aria-labelledby="accordion-product-viewer-specification" aria-hidden="true">
						<div class="c-accordion__content__inner">
							${details.Product.SpecificationTable.map(item => html`
							${item.Items.length ? html`
							<table class="c-table-striped c-table-striped--spec" ${!item.DisplayName ? html`data-test-no-group` : nothing}>
								<caption class="c-table-striped__caption" data-test="spec-table-group-title">
									${item.DisplayName}
								</caption>
								<tbody>
									${item.Items.map(item => html`
									<tr>
										<th scope="row">${item.DisplayName}</th>
										<td data-test="spec-table-cell-${item.DisplayName}">
										${item.HasLink
										? html`<a class=\"u-link js-show-variant-errors\" href=\"#slidy-outy-title\">${item.Value}</a>`
											: item.Value}
										</td>
									</tr>
									`)}
								</tbody>
							</table>
							` : nothing}
							`)}
						</div>
					</div>
					`
					: nothing}

					<h3 class="c-accordion__heading" data-test="product-viewer-reviews">
						<button type="button" class="c-accordion__title js-slide-toggle js-load-yotpo" data-yotpo-api-key="${details.Product.YotopoApiKey}" aria-controls="accordion-product-viewer-accordion-reviews-content" aria-expanded="false" data-transition-time="300" id="accordion-product-viewer-accordion-reviews" data-test="product-viewer-reviews-toggle">
							Reviews
						</button>
					</h3>

					<div class="c-accordion__content c-accordion__content--yotpo" id="accordion-product-viewer-accordion-reviews-content" data-test="product-viewer-reviews-content"  aria-labelledby="accordion-product-viewer-accordion-reviews" aria-hidden="true">
						<div class="c-accordion__content__inner">

							<div class="yotpo yotpo-main-widget"
								data-product-id="${details.Product.Id}"
								data-name="${details.Product.DisplayName}"
								data-url="${details.Product.Url}"
								data-image-url="${details.Product.Gallery.PrimaryGalleryItem.Url}"
								data-description="${details.Product.DisplayName}">
							</div>

						</div>
					</div>
				</div>

				<div class="c-slidy-outy__detail__action">
					<a .href="${details.Product.Url}" class="c-button c-button--secondary c-button--medium" data-test="product-viewer-view-details-link">View full product details</a>
				</div>

			</div>

		`;
	}

	renderProductInformation() {
		return this._productTask.render({
			pending: () => this.details ? this.renderProductDetails(this.details) : this.renderLoadingState(),
			complete: (details) => this.renderProductDetails(details),
			error: (e) => this.renderErrorState()
		});
	}

	render() {
		return html`
		<product-viewer-container standalone="${ifDefined(this.standalone ? true : undefined)}">
			<div slot="main">
				${this.renderProductInformation()}
			</div>
		</product-viewer-container>
		`
	}

}
